module.exports = __webpack_public_path__ + "static/img/user-header.3eeb3cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user-header.png
// module id = YghY
// module chunks = 11